import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M18 10l-6 -6l-6 6h12","key":"svg-0"}],["path",{"d":"M18 14l-6 6l-6 -6h12","key":"svg-1"}]]

const IconCaretUpDown = createReactComponent('outline', 'caret-up-down', 'CaretUpDown', __iconNode);

export default IconCaretUpDown;